var PartnerEvent = {}
// 竖版事件
PartnerEvent.Partner_Data_Update = "PartnerEvent.Partner_Data_Update"
PartnerEvent.Partner_Power_Event = "PartnerEvent.Partner_Power_Event"
PartnerEvent.Partner_Call_Event = "PartnerEvent.Partner_Call_Event"

PartnerEvent.Level_Red_Point = "PartnerEvent.Level_Red_Point"

PartnerEvent.Skill_Learn_Success = "PartnerEvent.Skill_Learn_Success"
PartnerEvent.Partner_Lev_Event = "PartnerEvent.Partner_Lev_Event"
PartnerEvent.Level_Panel_Close =  "PartnerEvent.Level_Panel_Close"

// 阵法相关
PartnerEvent.Form_List_Event = "PartnerEvent.Form_List_Event"
PartnerEvent.Form_Pos_Update = "PartnerEvent.Form_Pos_Update"
PartnerEvent.Use_Form_Success = "PartnerEvent.Use_Form_Success"
PartnerEvent.Form_Level_Event = "PartnerEvent.Form_Level_Event"
PartnerEvent.Form_Help_Select = "PartnerEvent.Form_Help_Select"

// 助阵事件
PartnerEvent.Form_Help_Data = "PartnerEvent.Form_Help_Data"
PartnerEvent.Form_UnLock_Data = "PartnerEvent.Form_UnLock_Data"
PartnerEvent.Form_Lev_Event = "PartnerEvent.Form_Lev_Event"
PartnerEvent.Form_Help_Red = "PartnerEvent.Form_Help_Red"

// 功能阵法相关
PartnerEvent.Update_Fun_Form = "PartnerEvent.Update_Fun_Form"

// 装备相关
PartnerEvent.Equip_Update_Event = "PartnerEvent.Equip_Update_Event"
PartnerEvent.Jing_Event= "PartnerEvent.Jing_Event"
// 神器相关

PartnerEvent.Artifact_Update_Event = "PartnerEvent.Artifact_Update_Event"
PartnerEvent.Artifact_UpStar_Event = "PartnerEvent.Artifact_UpStar_Event"
PartnerEvent.Artifact_Recast_Event = "PartnerEvent.Artifact_Recast_Event"
PartnerEvent.Artifact_Save_Event = "PartnerEvent.Artifact_Save_Event"
PartnerEvent.Artifact_Select_Event = "PartnerEvent.Artifact_Select_Event"


PartnerEvent.Partner_Treasure_LevelUp = "PartnerEvent.Partner_Treasure_LevelUp"
PartnerEvent.Partner_Treasure_JieUp = "PartnerEvent.Partner_Treasure_JieUp"

PartnerEvent.Partner_Treasure_SkillUp = "PartnerEvent.Partner_Treasure_SkillUp"

PartnerEvent.Partner_Chips_Change = "PartnerEvent.Partner_Chips_Change"
PartnerEvent.Update_Partner_Equip_Attr = "PartnerEvent.Update_Partner_Equip_Attr"
PartnerEvent.Update_Partner_Equip = "PartnerEvent.Update_Partner_Equip"

PartnerEvent.Save_Form_event = "PartnerEvent.Save_Form_event"

PartnerEvent.Save_Sell_equip = "PartnerEvent.Save_Sell_equip"

PartnerEvent.Red_point_Event = "PartnerEvent.Red_point_Event"

PartnerEvent.Star_Fail_Event = "PartnerEvent.Star_Fail_Event"

PartnerEvent.Lock_Equip_Event = "PartnerEvent.Lock_Equip_Event"

PartnerEvent.Form_Change_Event = "PartnerEvent.Form_Change_Event"

PartnerEvent.Partner_Attr_event = "PartnerEvent.Partner_Attr_event"

PartnerEvent.Del_Partner_Event = "PartnerEvent.Del_Partner_Event"

// 装备红点
PartnerEvent.Partner_Equip_Tishi = "PartnerEvent.Partner_Equip_Tishi"
// 伙伴神器事件
PartnerEvent.Artiface_Data_Event = "PartnerEvent.Artiface_Data_Event"

PartnerEvent.Del_One_Artiface = "PartnerEvent.Del_One_Artiface"
PartnerEvent.Update_Artiface_Data = "PartnerEvent.Update_Artiface_Data"

PartnerEvent.Artiface_Sysnthesis_Event = "PartnerEvent.Artiface_Sysnthesis_Event"

// 神器重铸
PartnerEvent.Recast_Data_Event = "PartnerEvent.Recast_Data_Event"


PartnerEvent.Fashion_Data_Event = "PartnerEvent.Fashion_Data_Event"

PartnerEvent.Equip_Recommend_Event = "PartnerEvent.Equip_Recommend_Event"

PartnerEvent.Equip_Sell_Event = "PartnerEvent.Equip_Sell_Event"


//  保存阵容成功事件
PartnerEvent.SaveFunFormEvent = "PartnerEvent.SaveFunFormEvent"

// 更新兑换成功
PartnerEvent.ChangeEvent = 'PartnerEvent.ChangeEvent'


//  宝石开孔
PartnerEvent.OpenGemStoneEvent = "PartnerEvent.OpenGemStoneEvent"

//  宝石更新
PartnerEvent.UpdateGemStoneEvent = "PartnerEvent.UpdateGemStoneEvent"

//  宝石合成成功
PartnerEvent.ComposeGemStoneEvent = "PartnerEvent.ComposeGemStoneEvent"

//  宝石升级成功
PartnerEvent.UpgradeGemStoneEvent = "PartnerEvent.UpgradeGemStoneEvent"

// 英雄重生
PartnerEvent.PartnerResetEvent = "PartnerEvent.PartnerResetEvent"
// 英雄遣散
PartnerEvent.PartnerDisbandEvent = "PartnerEvent.PartnerDisbandEvent"

module.exports = PartnerEvent;